module.exports = __webpack_public_path__ + "img/隐私计算.e541fce9.png";